import React, { PureComponent } from 'react';
import * as PropTypes from 'prop-types';
import WorkAreaFormGroup from './WorkAreaFormGroup';

export default class WorkAreaOutput extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      highlight: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.highlightOnUpdate &&
      this.props.value !== '' &&
      this.props.value !== prevProps.value
    ) {
      setTimeout(() => {
        this.setState({ highlight: false });
      }, 500);
      this.setState({ highlight: true });
    }
  }

  renderLabelText() {
    if (this.props.labelHTML === true || this.props.labelHTML === 1) {
      return <span dangerouslySetInnerHTML={{ __html: this.props.label }} />;
    } else {
      return this.props.label;
    }
  }

  renderUnits() {
    return (
      <span
        className="units-suffix"
        dangerouslySetInnerHTML={{ __html: this.props.units }}
      />
    );
  }

  render() {
    // show this input depending on some condition
    if (this.props.showIf) {
      const { comparison, value: comparisonValue } = this.props.showIf;
      switch (comparison) {
        case 'oneOf':
          if (comparisonValue.indexOf(this.props.depValue) < 0) {
            return null;
          }
          break;
        case 'eq':
          if (comparisonValue === this.props.depValue) {
            return null;
          }
          break;
        default:
          // no-op
          break;
      }
    }

    let classes =
      'd-flex align-items-baseline justify-content-end output text-nowrap';
    if (this.props.highlightOnUpdate === true) {
      classes += ' highlight';
    }
    if (this.state.highlight === true) {
      classes += ' highlight-on';
    }
    return (
      <WorkAreaFormGroup label={this.renderLabelText()}>
        <div className={classes}>
          {this.props.value}
          {this.props.units != '&nbsp;' ? (
            <>
              &nbsp;
              {this.renderUnits()}
            </>
          ) : null}
        </div>
      </WorkAreaFormGroup>
    );
  }
}

WorkAreaOutput.defaultProps = {
  label: '',
  labelHTML: false,
  units: '',
  value: '',
  highlightOnUpdate: true,
  showIf: null,
};

WorkAreaOutput.propTypes = {
  label: PropTypes.string,
  labelHTML: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  units: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  highlightOnUpdate: PropTypes.bool,
  showIf: PropTypes.shape({
    comparison: PropTypes.string,
    input: PropTypes.string,
    value: PropTypes.any,
  }),
};
